import { onClientSessionEnd } from "@/lib/session/onClientSessionEnd";
import { clearConsoleAccessToken } from "@/lib/auth/consoleAccessToken";
import { runCognitoLogout } from "@/lib/auth/runCognitoLogout";
import type { PublicRuntimeConfig } from "@/lib/config/publicRuntimeConfig";

/** Clears the client session, then signs out of Cognito (full-page redirect). */
export const postSessionLogout = async (
  config: PublicRuntimeConfig,
): Promise<void> => {
  await onClientSessionEnd();
  clearConsoleAccessToken();
  await runCognitoLogout(config);
};
